import {useContext} from "react";
import {IModalContext} from "../contexts/models/IModalContext.ts";
import {ModalContext} from "../contexts/ModalContext.tsx";

export const useModal = () => {
    return useContext<IModalContext>(ModalContext);
};